import ApiError from "../../errors/ApiError";
import { UNLINK_CUSTOMER_GUESTY_ERROR } from "./error-codes.constants";

export class UnlinkCustomerGuestyError extends ApiError {
  constructor() {
    super(UNLINK_CUSTOMER_GUESTY_ERROR);
  }
}
